import { L3vpnSubscriptionDetails } from "../../../pages/subscription-detail/types";

type L3vpnSap = L3vpnSubscriptionDetails["l3vpnsapss"][number];

export function transformL3vpnSap(sap: L3vpnSap) {
  return {
    ...sap,
    ...sap.sap,
    l3vpn_ipv4Address: sap.ipv4Address,
    l3vpn_ipv4RemoteAddress: sap.ipv4RemoteAddress,
    l3vpn_ipv6Address: sap.ipv6Address,
    l3vpn_ipv6RemoteAddress: sap.ipv6RemoteAddress,
  };
}

export type TransformedL3vpnSap = ReturnType<typeof transformL3vpnSap>;
